//Built-In
import React, {Fragment} from 'react';

//External
import cx from "classnames";

//Internal
import HeaderComponent from "./HeaderComponent";
import BodyComponent from "./BodyComponent";
import ButtonComponent from "./ButtonComponent";

export default class CarouselComponent extends React.Component{

    constructor(props) {
        super(props);
    }

    render(){

        let { component, formData, errors, useForm, controller, handleInputChange, handleChange, onFileUpload, leadFormDetail, previewData } = this.props;
        let cards = component && component.cards ? component.cards : [];
        return (
            <Fragment>
                <div className="carousel-inputs-container mt-3">
                    {cards.map((card, index) => {
                        let header = card.components ? card.components.find(c => c.type === 'HEADER') : null;
                        let bodyComponent = card.components ? card.components.find(c => c.type === 'BODY') : null;
                        let buttonsComponent = card.components ? card.components.find(c => c.type === 'BUTTONS') : null;
                        // Cards can carry an empty or whitespace-only body; skip the section entirely in that case.
                        let cardBodyText = bodyComponent && bodyComponent['text'] !== undefined ? bodyComponent['text'] : '';
                        let hasBodyText = String(cardBodyText).trim() !== '';
                        
                        return (
                            <div key={index} className="card-input-group mb-4 p-3 border rounded shadow-sm bg-white">
                                <h5 className="mb-3 text-primary border-bottom pb-2">Card {index + 1}</h5>
                                
                                {header && (
                                    <div className="header-variable-section mb-3">
                                        <HeaderComponent 
                                            useForm={useForm} 
                                            controller={controller} 
                                            formData={formData} 
                                            handleChange={handleChange} 
                                            handleInputChange={handleInputChange} 
                                            formDetail={leadFormDetail}
                                            onFileUpload={onFileUpload}
                                            errors={errors}
                                            component={header}
                                            hideUpload={this.props.hideUpload}
                                            isCarousel={true}
                                            cardIndex={index}
                                        />
                                    </div>
                                )}

                                {bodyComponent && hasBodyText && (
                                    <div className="body-variable-section">
                                        <BodyComponent
                                            source={`campaign`}
                                            useForm={useForm}
                                            controller={controller}
                                            values={formData}
                                            previewData={previewData}
                                            formDetail={leadFormDetail}
                                            handleChange={handleChange}
                                            handleInputChange={handleInputChange}
                                            component={bodyComponent}
                                            isCarousel={true}
                                            cardIndex={index}
                                        />
                                    </div>
                                )}

                                {buttonsComponent && buttonsComponent['buttons'] !== undefined && (
                                    <div className="button-variable-section mt-3">
                                        <ButtonComponent component={buttonsComponent} />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </Fragment>
        )
    }
}